// Turn a human title into a URL-safe slug, e.g. "NHSA Codes & Policies" -> "nhsa-codes-policies".
export const slugify = (value: string): string =>
  (value || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '') // drop non-alphanumerics
    .replace(/[\s_]+/g, '-') // spaces/underscores -> hyphen
    .replace(/-+/g, '-') // collapse repeated hyphens
    .replace(/^-|-$/g, ''); // trim leading/trailing hyphens

// Build the full path from the parent's full slug and this page's slug.
export const buildFullSlug = (parentFullSlug: string | undefined, slug: string): string => {
  const parent = (parentFullSlug || '').replace(/\/+$/, '');
  return parent ? `${parent}/${slug}` : slug;
};

// Public URL builders for content pages (buildPagePath, buildFullUrl, CONTENT_PATH_PREFIX)
// live in the `modules/infoHub` module — it owns the /content route prefix and is kept
// self-contained so it can be lifted into another project. Import them from its barrel.
